export const paths = {
  root: { path: "/", href: () => "/" },
  home: {
    path: "",
    href: () => "",
  },
  orderTrackingStatus: {
    path: "orders/:orderId/status/:hash",
    href: (orderId: string, hash: string) =>
      `/orders/${orderId}/status/${hash}`,
  },
  payment: {
    path: "orders/:orderId/payments/:hash",
    href: (orderId: string, hash: string) =>
      `/orders/${orderId}/payments/${hash}`,
  },
  success: {
    path: "success",
    href: () => "/success",
  },
  failed: {
    path: "failed",
    href: () => "/failed",
  },
  alreadyPaid: {
    path: "already-paid",
    href: () => "/already-paid",
  },
  // Payment provider callbacks
  paymentCallbackMoyasar: {
    path: "orders/:orderId/payments/moyasar",
    href: (orderId: string) => `/orders/${orderId}/payments/moyasar`,
  },
  paymentCallbackTamara: {
    path: "orders/payments/tamara",
    href: () => "/orders/payments/tamara",
  },
  paymentCallbackTabby: {
    path: "orders/payments/tabby/:result?",
    href: (result?: string) =>
      `/orders/payments/tabby${result ? `/${result}` : ""}`,
  },
  error: {
    path: "error",
    href: () => "/error",
  },
  orderConfirmed: {
    path: "orders/:orderId/confirmed",
    href: (orderId: string) => `/orders/${orderId}/confirmed`,
  },
} as const;
